import React from "react";
import { Form, Input } from "antd";

const FormTextarea = ({
  label,
  name,
  rules,
  placeholder,
  rows = 4,
  minLength = undefined,
  maxLength = undefined,
  showCount= false,
  ...rest
}) => {

  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      {...rest}
      className="custom-textarea"
    >
      <Input.TextArea
        placeholder={placeholder}
        rows={rows}
        minLength={minLength}
        maxLength={maxLength}
        showCount={showCount}
      />
    </Form.Item>
  );
};
export default FormTextarea;
